/**
 * Components: Beacon chat
 * ------------------------------------------------------------------------------
 * Updates chat button position on certain events.
 *
 * @namespace beaconChat
 */
import breakpoints from '~/helpers/breakpoints';
/**
 * DOM selectors.
 */

const selectors = {
  beaconButton: '.BeaconFabButtonFrame'
};
export default (() => {
  /**
   * Menu drawer open event handler.
   */
  function cartDrawerOpenHandler() {
    const beaconButton = document.querySelector(selectors.beaconButton);

    if (!beaconButton) {
      return;
    }

    if (window.matchMedia("(max-width: ".concat(breakpoints.small, ")")).matches) {
      beaconButton.style.display = 'none';
    }
  }
  /**
   * Cart drawer open event handler.
   */


  function menuDrawerOpenHandler() {
    const beaconButton = document.querySelector(selectors.beaconButton);

    if (!beaconButton) {
      return;
    }

    beaconButton.style.display = 'none';
  }
  /**
   * Cart drawer close event handler.
   */


  function cartDrawerCloseHandler() {
    const beaconButton = document.querySelector(selectors.beaconButton);

    if (!beaconButton) {
      return;
    }

    beaconButton.style.removeProperty('display');
  }
  /**
   * Set EventBus listeners for each instance.
   */


  function setEventBusListeners() {
    Frame.EventBus.listen(['Toggle:menuDrawer:open'], () => menuDrawerOpenHandler());
    Frame.EventBus.listen(['Toggle:menuDrawer:close'], () => cartDrawerCloseHandler());
    Frame.EventBus.listen('Toggle:cartDrawer:open', () => cartDrawerOpenHandler());
    Frame.EventBus.listen('Toggle:cartDrawer:close', () => cartDrawerCloseHandler());
  }
  /**
   * Initialise component.
   */


  function init() {
    setEventBusListeners();
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});